import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ConnectedCriteoZone from './CriteoZone';
import { getURLParameterBykey } from '../../utils';

/* istanbul ignore next */
export const GalleryCriteoZone = (props) => {
    let showCriteo = true;

    // disabling criteo on pagination
    const { pagination } = props;
    const page = pagination.selectedPageNumber || 0;
    if (page !== 1) {
        showCriteo = false;
    }

    // disabling criteo on sort
    const sort = getURLParameterBykey('sort');
    if (sort !== '') {
        showCriteo = false;
    }

    // disabling criteo on store filter > 1
    const stores = getURLParameterBykey('storeIds');
    if (stores !== '') {
        showCriteo = false;
    }

    return showCriteo ? <ConnectedCriteoZone page={props.page} /> : null;
};

GalleryCriteoZone.propTypes = {
    pagination: PropTypes.oneOfType([PropTypes.object]),
    page: PropTypes.string,
};

GalleryCriteoZone.defaultProps = {
    pagination: {},
    page: 'search',
};

export const mapStateToProps = (store) => ({
    pagination: store.pagination.pagination,
});

export default connect(mapStateToProps)(GalleryCriteoZone);
